var render = function render(){var _vm=this,_c=_vm._self._c;return _c('filter-group',{attrs:{"options":_vm.options,"title":_vm.filter.text,"id":_vm.fKey,"selected":_vm.filter.value,"first-option":_vm.filter.firstOption,"background-color":_vm.filter.backgroundColor,"clear":true,"single-select":_vm.filter.singleSelect},on:{"set-filter":_vm.setFilter}})
}
var staticRenderFns = []

export { render, staticRenderFns }